<ng-container *ngIf="{
  request: requestPowerAndEnergies$ | async,
  requestStatus: requestsIsPending$ | async,
} as resolver">
  <ng-container *ngIf="pageData$ | async as pageData; else noDataSkeleton">
    <calendar-picker
      *ngIf="showCalendarPicker"
      id="calendar-picker"
      class="w-full fx-row fx-align-baseline"
      startView="month"
      [ngClass]="{ 'visibility: hidden': todayMode }"
      [disabled]="resolver.requestStatus || false"
      (dateSelected)="dateSelection$.next($event); updateDateSelection()">
      <button
        *ngIf="pageData.powerData.hasValues && system?.source === 'aws'"
        class="custom-mat-button-primary ml-0 custom-mat-button-border"
        mat-button
        (click)="onExport(pageData.powerData.graph.series)">
        <mat-icon class="m-0">download</mat-icon>
      </button>
      <button
        class="custom-mat-button-primary ml-0 custom-mat-button-border"
        mat-button
        [disabled]="!pageData.powerData.hasValues"
        (click)="zoomedChange.emit(!zoomed)">
        <mat-icon class="m-0">{{ zoomed ? 'zoom_out' : 'zoom_in' }}</mat-icon>
      </button>
    </calendar-picker>
    <lib-block-title
      *ngIf="showPowerTitle"
      id="power-title"
      [title]="labels.title">
    </lib-block-title>
    <app-custom-source-selector
      *ngIf="sourceOptions$ | async as sourceOptions"
      id="source-selector"
      [source]="sourceSelection$.value"
      [options]="sourceOptions"
      (selection)="updateSourcesSelection($event)">
    </app-custom-source-selector>
    <div
      *ngIf="pageData.powerData.hasValues; else noData"
      id="power-chart"
      class="w-full block-bg-contrast"
      echarts
      [options]="pageData.powerData.graph"
      (chartInit)="onChartInit($event)">
    </div>

    <ng-template #noData>
      <div
        id="power-chart"
        class="w-full block-bg-contrast fx-col fx-center fx-gap-3">
        <mat-icon
          class="s-20"
          svgIcon="no_data">
        </mat-icon>
        <span class="text-grey-400 tw-font-normal tw-text-base">
          {{ labels.noDataForTheSelectedPeriod }}
        </span>
      </div>
    </ng-template>

    <div
      *ngIf="showEnergyOverview"
      id="energy-overview">
      <app-key-value-block
        *ngFor="let item of pageData.energyData"
        class="energy-item fx-center"
        [key]="labels[item.name]"
        [value]="(item.value | number: '1.0-2': locate) + ' ' + item.unit"
        [bgColor]="item?.bgColor">
      </app-key-value-block>
    </div>
  </ng-container>
</ng-container>

<ng-template #noDataSkeleton>
  <ion-skeleton-text
    *ngIf="showPowerTitle"
    id="power-title"
    class="w-50 h-16"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="power-chart"
    class="s-full fx-center"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    *ngIf="showCalendarPicker"
    id="calendar-picker"
    class="w-90 h-16"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="source-selector"
    class="w-full h-16"
    [animated]="true">
  </ion-skeleton-text>
  <div
    *ngIf="showEnergyOverview"
    id="energy-overview"
    class="s-full">
    <ion-skeleton-text
      *ngFor="let _ of [].constructor(6)"
      class="s-full h-32 radius-4"
      [animated]="true">
    </ion-skeleton-text>
  </div>
</ng-template>
